// @ts-check
// =============================================================================
// js/app/debug.js — the ?debug developer panel (cross-cutting.md).
//
// WHAT THIS IS
//   Debug tooling stays BEHIND the ?debug flag — normal play ships silent
//   (no window.* dumps, no chatty logs). With "?debug" in the URL this module
//   exposes window.DB with the store + a few levers, so a developer (or an
//   automated browser test) can inspect state and drive the duel screen with
//   synthetic 'Duel Update' payloads — the Phase 1 "temporary debug entry".
//
//   window.DB = {
//     store,                     // live state slices (read)
//     setSlice, navigate,        // poke state / routing
//     injectDuel(duel),          // feed a state through the Duel Update path
//     click(spot),               // drive the duel targeting machine
//     targeting,                 // current selection/sources/targets
//   }
// =============================================================================

import { store, setSlice } from '../core/store.js';
import { navigate } from '../core/router.js';
import { simulateDuelUpdate, simulateChat } from '../net/socket.js';
import { click, targeting } from '../screens/duel/targeting.js';

/**
 * Install window.DB when ?debug is present. Called once from boot.
 * @returns {void}
 */
export function initDebug() {
	if (!window.location.search.includes('debug')) return;
	/** @type {any} */ (window).DB = {
		store,
		setSlice,
		navigate,
		injectDuel: simulateDuelUpdate,
		injectChat: simulateChat,
		click,
		targeting,
	};
	console.log('🐛 Debug mode: window.DB is live');
}
